import { create } from "zustand";
import { INITIAL_BODY } from "@/const/initialBody";
import { BodyPart } from "@/types/design";

type StateType = {
	body: BodyPart[];
	setBody: (initialBody: BodyPart[]) => void;
	updateBody: (updatedBody: BodyPart[]) => void;
	resetBody: () => void;
};

export const bodyStore = create<StateType>((set) => ({
	body: INITIAL_BODY,
	setBody: (initialBody: BodyPart[]) => set({ body: initialBody }),
	updateBody: (newBody: BodyPart[]) => set({ body: newBody }),
	resetBody: () => set({ body: INITIAL_BODY }),
}));
